import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=48fe2480&scoped=true&"
import script from "./SuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&id=48fe2480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe2480",
  null
  
)

export default component.exports